import Typography from "@shared/v2/Typography";
import { CircleCheckSolidV6 } from "@shared/v2/Icomoon";

const DitlAllDoneCard = () => (
  <div className="tw-flex tw-flex-col tw-items-center tw-gap-[8px] tw-w-full tw-p-[24px] tw-bg-white tw-rounded-[12px] tw-border-[1px] tw-border-solid tw-border-gray-10 tw-shadow-[0px_2px_8px_0px_rgba(213,213,213,0.5)]">
    <CircleCheckSolidV6 className="tw-w-[24px] tw-h-[24px] tw-text-semantic-green-100" />
    <Typography variant="headline1" component="p" className="tw-text-center">
      You’re all caught up!
    </Typography>
  </div>
);

export default DitlAllDoneCard;
